<script>

export default {
  name: "Checkbox",
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: Boolean,
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
  },
  methods: {
    handle() {
      if (!this.disabled) {
        this.$emit('change', !this.checked)
      }
    }
  }
}
</script>

<template>
  <div
    class="custom-checkbox-wrapper"
    :class="{ disabled: disabled }"
    @click="handle"
  >
    <div class="checkbox" :class="{ checked: checked }">
      <svg v-if="checked" width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.3333 1L5.00001 8.33333L1.66667 5" stroke="#FB923C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <div v-if="$slots.default" class="checkbox-label">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.checkbox {
  /* Checkbox */

  /* Auto layout */
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;

  width: 20px;
  height: 20px;


  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  /* _Checkbox base */

  box-sizing: border-box;

  /* Gray/300 */
  border: 1px solid #D5D7DA;
  border-radius: 6px;
}
.checkbox.checked {
  /* _Checkbox base */

  box-sizing: border-box;

  width: 20px;
  height: 20px;

  border: 1px solid #FB923C;
  border-radius: 6px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;

  &::after {
    content: "";
    color: #FB923C;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
.checkbox-label {
  display: flex;
  align-items: center;
}
</style>
